
export const INSTRUMENT_BRANDS = {
    GUITAR: {
        TURKISH: [
            'Sire Guitars',
            'Tone King (Türkiye)',
            'Anatolian Guitars',
            'İstanbul Gitar',
            'Bosphorus Strings',
            'Aegean Guitars'
        ],
        BOUTIQUE: [
            'Kiesel', 'Strandberg', 'Balaguer', 'Kauer', 'Ronin',
            'Aristides', 'Skervesen', 'Mayones', 'Jericho', 'Anderson', 'Suhr'
        ],
        MAJOR: [
            'Fender', 'Gibson', 'Ibanez', 'PRS', 'ESP', 'Schecter', 'Jackson', 'Charvel',
            'Yamaha', 'Epiphone', 'Squier', 'Gretsch', 'Taylor', 'Martin', 'Cort'
        ],
        AFFORDABLE: [
            'Harley Benton', 'Firefly', 'Glarry', 'Donner', 'Joyo', 'Mooer', 'Floyd'
        ],
        SUSTAINABLE: [
            'Taylor (V-Class bracing)', 'Martin (Sustainable Wood)', 'Fender (Player Plus Series)', 'Yamaha (Transacoustic)', 'Cort (Earth Series)'
        ]
    }
};

export const GUITAR_FILTERS = [
    {
        key: 'body_wood',
        label: 'Gövde Ağacı',
        type: 'select',
        options: ['Mahogany (Maun)', 'Alder (Kızılağaç)', 'Ash (Dişbudak)', 'Basswood (Ihlamur)', 'Poplar (Kavak)', 'Swamp Ash', 'Maple', 'Walnut', 'Koa', 'Rosewood', 'Ebony'],
        multiSelect: true
    },
    {
        key: 'neck_wood',
        label: 'Sap Ağacı',
        type: 'select',
        options: ['Maple', 'Mahogany', 'Roasted Maple', 'Walnut', 'Wenge', 'Composite']
    },
    {
        key: 'fingerboard_wood',
        label: 'Klavye Ağacı',
        type: 'select',
        options: ['Rosewood', 'Maple', 'Ebony', 'Pau Ferro', 'Richlite', 'Composite']
    },
    {
        key: 'pickup_configuration',
        label: 'Manyetik Konfigürasyonu',
        type: 'select',
        options: ['SSS', 'SS', 'HH', 'HS', 'HSS', 'HSH', 'P90 Set', 'Filter\'tron', 'Lipstick']
    },
    {
        key: 'bridge_type',
        label: 'Köprü Tipi',
        type: 'select',
        options: ['Fixed Bridge', 'Tremolo (6-screw)', '2-Point Tremolo', 'Floyd Rose', 'Bigsby', 'Hardtail', 'Tune-o-matic', 'Wrap-around']
    },
    {
        key: 'scale_length',
        label: 'Mensur Uzunluğu',
        type: 'select',
        options: ['24" (610mm)', '24.75" (629mm)', '25" (635mm)', '25.5" (648mm)', '27" (Baritone)', 'Multi-scale']
    },
    {
        key: 'neck_profile',
        label: 'Sap Profili',
        type: 'select',
        options: ['C Shape', 'D Shape', 'V Shape', 'U Shape', 'Modern C', 'Slim Taper', 'Baseball Bat', 'Asymmetric']
    },
    {
        key: 'fret_size',
        label: 'Perde Büyüklüğü',
        type: 'select',
        options: ['Vintage Small', 'Medium Jumbo', 'Jumbo', 'Extra Jumbo', 'Stainless Steel', 'EVO Gold']
    },
    {
        key: 'number_of_frets',
        label: 'Perde Sayısı',
        type: 'select',
        options: ['21', '22', '24', '27', '30+']
    },
    {
        key: 'electronics',
        label: 'Elektronik Özellikler',
        type: 'select',
        options: ['Passive', 'Active (9v)', 'Active (18v)', 'Coil Tap/Split', 'Phase Switching', 'Series/Parallel', 'Treble Bleed', 'No-Load Pot'],
        multiSelect: true
    },
    {
        key: 'finish_type',
        label: 'Bitiş Türü',
        type: 'select',
        options: ['Gloss (Parlak)', 'Satin (Mat)', 'Open Pore', 'Oil Finish', 'Natural', 'Relic']
    },
    {
        key: 'left_handed',
        label: 'Solak Model',
        type: 'checkbox'
    },
    {
        key: 'country_of_origin',
        label: 'Üretim Yeri',
        type: 'select',
        options: ['USA', 'Japan', 'Mexico', 'China', 'Indonesia', 'Korea', 'Turkey', 'Germany', 'Czech Republic', 'Custom Shop']
    }
];

export const PIANO_KEYS = ['25', '32', '49', '61', '73', '76', '88'];
export const PIANO_ACTION = ['Weighted (Ağırlıklı)', 'Semi-Weighted', 'Hammer Action', 'Synth Action'];

export const DRUM_PIECES = ['3-Piece', '4-Piece', '5-Piece', '6-Piece', '7+ Piece'];
export const DRUM_SHELL = ['Maple (Akçaağaç)', 'Birch (Huş)', 'Mahogany (Maun)', 'Poplar (Kavak)', 'Oak (Meşe)', 'Metal'];

export const STRING_SIZES = ['1/16', '1/10', '1/8', '1/4', '1/2', '3/4', '4/4 (Tam Boy)'];
